import { render, staticRenderFns } from "./PersonCreate.vue?vue&type=template&id=7f217a90&"
import script from "./PersonCreate.vue?vue&type=script&lang=ts&"
export * from "./PersonCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports